module.exports = __webpack_public_path__ + "images/3fe5d6fc376108741ff5c60e09cec50bf.svg";